import { Chip as MuiChip, SxProps, Theme, useTheme } from '@mui/material';
import { FC, ReactElement } from 'react';
import { OverridableStringUnion } from '@mui/types';
import {
  ChipPropsColorOverrides,
  ChipPropsSizeOverrides,
  ChipPropsVariantOverrides,
} from '@mui/material/Chip/Chip';

interface Props {
  disabled?: boolean;
  label: string;
  icon?: ReactElement;
  variant?: OverridableStringUnion<'filled' | 'outlined', ChipPropsVariantOverrides>;
  size?: OverridableStringUnion<'small' | 'medium', ChipPropsSizeOverrides>;
  color?: OverridableStringUnion<
    'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
    ChipPropsColorOverrides
  >;
  onClick?: () => void;
  onDelete?: () => void;
  sx?: SxProps<Theme>;
}

const Chip: FC<Props> = ({
  disabled,
  label,
  icon,
  onDelete,
  variant,
  size,
  color,
  onClick,
  sx,
}) => {
  const theme = useTheme();
  return (
    <MuiChip
      disabled={disabled}
      label={label}
      icon={icon}
      variant={variant}
      size={size}
      color={disabled ? 'default' : color}
      onClick={onClick}
      onDelete={onDelete}
      sx={{
        mt: theme.spacing(1),
        mr: theme.spacing(1),
        ml: -theme.spacing(1),
        mb: theme.spacing(1),
        ...sx,
      }}
    />
  );
};

export default Chip;
